import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        base: 'w-full',
    },
} satisfies TVConfig<typeof ui>['selectMenu'];
